import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

// EInvoice sayfasına bu kaynak verildiğinde satış faturası bu uçtan alınır.
export const URUN_FIYAT_FARKI_INVOICE_SOURCE = 'vdf-urun-fiyat-farki'

export class GetUrunFiyatFarkiInvoiceApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetUrunFiyatFarkiInvoice',
      requesterInfo,
    })
  }

  public async getEInvoiceAddress(request: any): Promise<string> {
    return await this.postAsync<string>(request)
  }
}
